import React from 'react';
import { connect } from 'react-redux';
import { Table, Button } from 'react-bootstrap';
import Draggable from 'react-draggable';
import _ from 'lodash';
import moment from 'moment';

import momentDurationFormatSetup from '../../../util/moment-duration';
import { saveConfig, updateBlockersChart } from '../../../components/Filter/FilterActions';

export class BlockersStats extends React.Component {
  constructor(props) {
    super(props);

    this.handleClose = this.handleClose.bind(this);
  }

  handleClose() {
    this.props.close(this.props.chart);
    this.props.saveConfig();
  }

  render() {
    const { markBlocked, chart, data, timePrecision, id } = this.props;
    const isAging = chart === 'cta';

    if (!data || !data.length) {
      return <div></div>;
    }

    let rows = data.map((item) => {
      return (
        <tr key={item.list}>
          <td>
            <div className="label_box" style={{ background: item.color }}></div>
            {item.list}
          </td>
          <td>{item.total > 0 ? item.total : '---'}</td>
          {isAging && <td>{item.total > 0 ? item.currentlyBlocked : '---'}</td>}
          {isAging && <td>{item.total > 0 ? item.wasBlocked : '---'}</td>}
          <td>
            {item.total > 0
              ? `${moment
                  .duration(item.accumulatedMinutes, 'minutes')
                  .format(timePrecision || 'd[d] h[h] m[m]', { trim: 'mid both' })}`
              : '---'}
          </td>
          <td>{item.total > 0
              ? `${moment
                  .duration(item.average, 'minutes')
                  .format(timePrecision || 'd[d] h[h] m[m]', { trim: 'mid both' })}`
              : '---'}
          </td>
        </tr>
      );
    });

    return (
      <Draggable defaultPosition={{ x: 95, y: isAging ? 112 : 85 }} axis="both" bounds="parent">
        <div id={id} className="box_white_shadow table_metrics">
          <h3>Blockers</h3>
          {!markBlocked && (
            <div className="time_spent_box">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M19.5276 21.2795C21.0676 21.2795 22.0276 19.6095 21.2576 18.2795L13.7276 5.26947C12.9576 3.93947 11.0376 3.93947 10.2676 5.26947L2.73756 18.2795C1.96756 19.6095 2.92756 21.2795 4.46756 21.2795H19.5276ZM11.9976 14.2795C11.4476 14.2795 10.9976 13.8295 10.9976 13.2795V11.2795C10.9976 10.7295 11.4476 10.2795 11.9976 10.2795C12.5476 10.2795 12.9976 10.7295 12.9976 11.2795V13.2795C12.9976 13.8295 12.5476 14.2795 11.9976 14.2795ZM10.9976 16.2795V18.2795H12.9976V16.2795H10.9976Z" fill="#B37100"/>
              </svg>
              <span>
                To see blocker data in your widget, make sure the <b>Blocked issues</b><br/>
                checkbox is enabled in the right panel.
              </span>
            </div>
          )}
          <Button className="btn-close" onClick={this.handleClose}>
            &times;
          </Button>
          <Table condensed>
            <thead>
              <tr>
                <th>&nbsp;</th>
                <th>
                  Total
                </th>
                {isAging && <th>
                  Currently <br />
                  blocked
                </th>}
                {isAging && <th>
                  Blocked <br />
                  in the past
                </th>}
                <th>
                  Accumulated <br />
                  time
                </th>
                <th>
                  Average
                </th>
              </tr>
            </thead>
            <tbody>{rows}</tbody>
          </Table>
        </div>
      </Draggable>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    close: (chart) => dispatch(updateBlockersChart(false, chart)),
    saveConfig: () => dispatch(saveConfig()),
  };
};

const mapStateToProps = (state) => {
  const chart = state.filters.chart;
  return {
    chart: state.filters.chart,
    markBlocked: state.filters[chart].markBlocked,
    timePrecision: state.filters.timePrecision,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(BlockersStats);
